export default "__VITE_ASSET__9bf033cb__"